import React from "react"

import HealthArticleListing from "./ListingTypes/HealthArticleListing"
import SocialArticleListing from "./ListingTypes/SocialArticleListing"
import AboutArticleListing from "./ListingTypes/AboutArticleListing"
import ImportedArticleListing from "./ListingTypes/ImportedArticleListing"
import PageListing from "./ListingTypes/PageListing"
// import ListingAU from "./FullListing/ListingAU"
// import ListingNZ from "./FullListing/ListingNZ"

//import { useLocale } from "../../context/LocaleContext"

import { ListingModule } from "../../models/modules"

export interface ListingProps extends ListingModule {
  cssClass?: string
  hasSidebar?: boolean
  pageContext: any
}

const defaultProps = {}

export const Listing: React.FC<ListingProps> = props => {
  if (!props.listing_type) return null

  // context
  //const { locale } = useLocale().localeData
  //const LocaleListing = locale === "en-au" ? ListingAU : ListingNZ

  if (props.listing_type === "Articles - Health & Nutrition")
    return (
      <HealthArticleListing
        {...props}
        hasSidebar={props.hasSidebar}
        pageContext={props.pageContext}
      />
    )

  if (props.listing_type === "Articles - Social Purpose")
    // return <LocaleListing {...props} hasSidebar={props.hasSidebar} />
    return (
      <SocialArticleListing
        {...props}
        hasSidebar={props.hasSidebar}
        pageContext={props.pageContext}
      />
    )

  if (props.listing_type === "Articles - About")
    return (
      <AboutArticleListing
        {...props}
        hasSidebar={props.hasSidebar}
        pageContext={props.pageContext}
      />
    )

  if (props.listing_type === "Content Pages")
    return (
      <PageListing
        {...props}
        hasSidebar={props.hasSidebar}
        pageContext={props.pageContext}
      />
    )

  return (
    <ImportedArticleListing
      {...props}
      hasSidebar={props.hasSidebar}
      pageContext={props.pageContext}
    />
  )
}

Listing.defaultProps = defaultProps

export default Listing
